/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindSupplierMappingFilteringOptionsQueryResponse } from "../types/FindSupplierMappingFilteringOptions.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findSupplierMappingFilteringOptionsQueryKey = () =>
  [
    { url: "/v1/client-settings/find-supplier-mapping-filtering-options" },
  ] as const

export type FindSupplierMappingFilteringOptionsQueryKey = ReturnType<
  typeof findSupplierMappingFilteringOptionsQueryKey
>

/**
 * @summary Find supplier mapping filtering options
 * {@link /v1/client-settings/find-supplier-mapping-filtering-options}
 */
export async function findSupplierMappingFilteringOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindSupplierMappingFilteringOptionsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-supplier-mapping-filtering-options`,
    ...requestConfig,
  })
  return res
}

export function findSupplierMappingFilteringOptionsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findSupplierMappingFilteringOptionsQueryKey()
  return queryOptions<
    ResponseConfig<FindSupplierMappingFilteringOptionsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindSupplierMappingFilteringOptionsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findSupplierMappingFilteringOptions({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find supplier mapping filtering options
 * {@link /v1/client-settings/find-supplier-mapping-filtering-options}
 */
export function useFindSupplierMappingFilteringOptions<
  TData = ResponseConfig<FindSupplierMappingFilteringOptionsQueryResponse>,
  TQueryData = ResponseConfig<FindSupplierMappingFilteringOptionsQueryResponse>,
  TQueryKey extends QueryKey = FindSupplierMappingFilteringOptionsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindSupplierMappingFilteringOptionsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findSupplierMappingFilteringOptionsQueryKey()

  const query = useQuery(
    {
      ...findSupplierMappingFilteringOptionsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
